module.exports = __webpack_public_path__ + "static/media/ProximaNova-Extrabld.169bc0f1.eot";